import { Link, useHistory } from 'react-router-dom';
import WhitePad from '../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../components/common/forms/Title/TitleComponent';
import { ROLES } from '~/src/utils/constants';
import RolesDependent from '~/src/components/common/RolesDependent';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import styled from 'styled-components';
import { Colors } from '~/src/scss/common/style';
import ExternalOwnerConsolidations from '~/src/components/common/consolidationWidget/ExternalOwnerConsolidations';
import { useContext } from 'react';
import MyContext from '~/src/services/context';
import { INTEGRATION_TYPE } from '~/src/utils/integrationsConstants';

export default function HomePage(): JSX.Element {
  const history = useHistory();
  const context = useContext(MyContext);


  return (
    <WhitePad>
      <TitleComponent title="Home" />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ul>
          <li>
            <div>Orders</div>
            <ul>
              <RolesDependent
                roles={[
                  ROLES.ADMIN,
                  ROLES.SUPER_ADMIN,
                  ROLES.WAREHOUSE_ADMIN,
                  ROLES.WAREHOUSE,
                  ROLES.OFFICE,
                  ROLES.SALES,
                  ROLES.DATABASE_ADMIN,
                  ROLES.WAREHOUSE_EXTERNAL_USER,
                  ROLES.SVILA_CLIENT_ADMIN,
                  ROLES.SVILA_CLIENT
                ]}
              >
                <li>
                  <Link to="/orders-list">Sell Orders</Link>
                </li>
                <li>
                  <Link to="/purchase-orders">Purchase Orders</Link>
                </li>
              </RolesDependent>
              {
                context.user?.activeIntegrations?.includes(INTEGRATION_TYPE.GOMBA_SHOP.label) && (
                  <><RolesDependent
                    roles={[
                      ROLES.ADMIN,
                      ROLES.SUPER_ADMIN,
                      ROLES.WAREHOUSE_ADMIN,
                      ROLES.WAREHOUSE,
                      ROLES.OFFICE,
                      ROLES.SALES,
                      ROLES.DATABASE_ADMIN,
                      ROLES.SVILA_CLIENT_ADMIN,
                      ROLES.SVILA_CLIENT
                    ]}
                  >
                    <li>
                      <Link to="/orders/fnb">Fnb/Gomba Mirror Orders</Link>
                    </li>
                    <li>
                      <Link to="/orders/fnb-consolidations">Fnb/Gomba Orders of KC Travel</Link>
                    </li>
                  </RolesDependent>
                    {
                      <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.FNB, ROLES.SVILA_CLIENT_ADMIN, ROLES.SVILA_CLIENT]}>
                        <li>
                          <Link to="/orders/fnb-status">FNB Order Status</Link>
                        </li>
                      </RolesDependent>
                    }
                    <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}>
                      <li>
                        <Link to="/orders/fnb-invoices">Fnb Invoices</Link>
                      </li>
                    </RolesDependent></>
                )
              }
            </ul>
          </li>
          <li>
            <div>Warehouses</div>
            <ul>
              <RolesDependent
                roles={[
                  ROLES.ADMIN,
                  ROLES.SUPER_ADMIN,
                  ROLES.WAREHOUSE,
                  ROLES.WAREHOUSE_ADMIN,
                  ROLES.WAREHOUSE_EXTERNAL_USER,
                ]}
              >
                <li>
                  <Link to="/inventory">Sevlievo - New</Link>
                </li>
              </RolesDependent>
              <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.WAREHOUSE_ADMIN, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}>
                <li>
                  <Link to="/warehouses">Warehouses</Link>
                </li>
              </RolesDependent>
            </ul>
          </li>
          <li>
            <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}>
              <Link to="/products">Products</Link>
            </RolesDependent>
            <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}>
              <ul>
                <li>
                  <Link to="/brands">Brands</Link>
                </li>
                <li>
                  <Link to="/ingredients">Ingredients</Link>
                </li>
                <li>
                  <Link to="/hscodes">HS Codes</Link>
                </li>
                <li>
                  <Link to="/categories">Categories</Link>
                </li>
                <li>
                  <Link to="/pallets">Pallets</Link>
                </li>
                <li>
                  <Link to="/containers">Containers</Link>
                </li>
                <li>
                  <Link to="/packages">Packages</Link>
                </li>
                <li>
                  <Link to="/labels">Labels</Link>
                </li>
                <li>
                  <Link to="/storage-conditions">Storage Conditions</Link>
                </li>
              </ul>
            </RolesDependent>
          </li>
          <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE, ROLES.SVILA_CLIENT, ROLES.SVILA_CLIENT_ADMIN]}>
            <li>
              <div>Contractors</div>
              <ul>
                <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}>
                  <li>
                    <Link to="/manufacturers">Manufacturers</Link>
                  </li>
                </RolesDependent>
                <li>
                  <Link to="/suppliers">Suppliers</Link>
                </li>
                <li>
                  <Link to="/customers">Customers</Link>
                </li>
                <li>
                  <Link to="/warehouse-owners">Warehouse Owners</Link>
                </li>
              </ul>
            </li>
          </RolesDependent>
          <li>
            <div>Other</div>
            <ul>
              <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN, ROLES.OFFICE]}>
                <li>
                  <Link to="/transport-pricings">Transport Pricings</Link>
                </li>
              </RolesDependent>
              <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}>
                <li>
                  <Link to="/nutrition">Nutrition</Link>
                </li>
              </RolesDependent>
            </ul>
          </li>
          <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SVILA_CLIENT_ADMIN]}>
            <li>
              <Link to="/users">Users</Link>
            </li>
          </RolesDependent>
          <RolesDependent roles={[ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.DATABASE_ADMIN]}>
            <li>
              <Link to="/data-operations">Data Operations</Link>
            </li>
          </RolesDependent>
        </ul>
        {/* <FormWrapper width="auto"> */}
        <RolesDependent
          roles={[
            ROLES.ADMIN,
            ROLES.SUPER_ADMIN,
            ROLES.SALES,
            ROLES.OFFICE,
            ROLES.WAREHOUSE,
            ROLES.DATABASE_ADMIN,
            ROLES.WAREHOUSE_EXTERNAL_USER,
            ROLES.WAREHOUSE_ADMIN,
          ]}
        >
          <ExternalOwnerConsolidations />
        </RolesDependent>
        {/* </FormWrapper> */}
      </div>
    </WhitePad>
  );
}

const Title = styled.h1`
  color: ${Colors.darkBrown};
  padding: 0;
  font-size: 20px;
`;

const Wrapper = styled.div`
  padding: 45px 60px;
  background-color: #f4f4f4;
  border-radius: 10px;
  width: 650;
  height: min-content;
`;
